export default __webpack_public_path__ + "static/media/qw.dd5a3f08.png";